import PERFIL from '@/constants/perfil'
import Home from './Home'
import Gerais from './gerais/Gerais'
import OS from './os/OS'
import DetalhesOS from './os/DetalhesOS'

const setRouteGroup = group => {
  return { routeGroup: group }
}

export const items = [
  {
    path: '/home',
    name: 'relatorios/home',
    component: Home
  },
  /* Gerais */
  {
    path: 'gerais',
    name: 'relatorios/gerais',
    component: Gerais,
    props: true,
    meta: {
      menu: 'relatorios/gerais',
      perfis: PERFIL.RELATORIOS.RELATORIOS.codigo,
      ...setRouteGroup('RELATORIOS')
    }
  },
  /* OS */
  {
    path: 'os',
    name: 'relatorios/os',
    component: OS,
    props: true,
    meta: {
      menu: 'relatorios/os',
      perfis: PERFIL.RELATORIOS.RELATORIOS.codigo,
      ...setRouteGroup('RELATORIOS')
    }
  },
  {
    path: 'detalhes/os/:id',
    name: 'relatorios/os/detalhes',
    component: DetalhesOS,
    props: true,
    meta: {
      menu: 'relatorios/os/detalhes',
      perfis: PERFIL.RELATORIOS.RELATORIOS.codigo,
      ...setRouteGroup('RELATORIOS')
    }
  }
]



// WEBPACK FOOTER //
// ./src/screens/relatorios/config.js